import { translation as t } from "../utils/translation";
import { ICONS } from "../assets";
const Footer = () => {
  return (
    <div id="footer" className="flex justify-between h-xxl">
      <div className="flex-5 bg-blue ml-5 pr-10 leading-extra-loose rounded-m text-white font-bold text-30">
        {t.LEUMI_SLOGEN}
      </div>
      <div className="flex-1 flex justify-center items-center rounded-m bg-lightBlue">
        <img
          src={ICONS.LOGO_WIDE}
          alt={t.ACCESSIBILITY.LOGO_LEUMI}
          title={t.ACCESSIBILITY.LOGO_LEUMI}
        />
      </div>
    </div>
  );
};
export default Footer;